import BigNumber from 'bignumber.js';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import Icon, { ContractType } from '../../../external/components/Icon/Icon';
import Text from '../../../external/components/Text/Text';
import networkHelpers from '../../../helpers/network.helpers';
import { NetworkId } from '../../../types/network.types';
import { timeHelpers } from '../helpers/timeHelpers';

interface HighlightProps extends React.HtmlHTMLAttributes<HTMLElement> {
  amount: string;
  timestamp: string;
  tokenDecimals: number;
  symbol: ContractType;
  networkId: NetworkId;
  id: string;
  type: 'Staked' | 'Unstaked' | 'Claimed';
}

const StyledCardWrapper = styled.div`
  border-radius: 14px;
  background: #201f1e;
  position: relative;

  & + & {
    margin-top: 1.5rem;
  }
`;

export const StakingTransactionCardInner = styled.div`
  padding: 0.75rem 1rem;
`;

export const StakingTransactionCardFooter = styled.div`
  padding: 0.75rem 1rem;
  background: #161b27;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledLink = styled.a`
  color: #630e17;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  :hover {
    text-decoration: none;
  }
`;

export function StakingTransactionCard({
  children,
  tokenDecimals,
  networkId,
  symbol,
  amount,
  timestamp,
  id,
  type,
  ...props
}: PropsWithChildren<HighlightProps>) {
  return (
    <StyledCardWrapper {...props}>
      <StakingTransactionCardInner>
        <div className='flex align-center justify-space-between'>
          <Text dark={true}>{type}</Text>
          <Text dark={true}>{timeHelpers.shortDate(parseInt(timestamp) || 0)}</Text>
        </div>
        <Text dark={true} size='xl' as='span'>
          {new BigNumber(amount)
            .shiftedBy(-tokenDecimals)
            .toNumber()
            .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 })}
        </Text>
        <Text size='xl' as='span' style={{ color: '#ffffff', marginLeft: '0.25rem' }}>
          {symbol}
        </Text>
      </StakingTransactionCardInner>
      <StakingTransactionCardFooter>
        <>
          <StyledLink
            href={`${networkHelpers.findBlockExplorerUrl(networkId)}/tx/${id}`}
            rel='noopener noreferrer'
            style={{ color: '#ffffff' }}
            target='_blank'
          >
            {id.substring(0, 10)}
            {'...'}{' '}
            <Icon type='external' style={{ color: '#ffffff', marginLeft: '0.25rem' }}></Icon>
          </StyledLink>
        </>
      </StakingTransactionCardFooter>
    </StyledCardWrapper>
  );
}
